import { render, staticRenderFns } from "./language-wrapper.vue?vue&type=template&id=334a4eea"
import script from "./language-wrapper.ts?vue&type=script&lang=js&external"
export * from "./language-wrapper.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports